/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { memo } from "react";

// CSS読み込み
import {
  mtgBody,
  mtgCaption,
  modalImg,
  modalLabel,
  modalGroup
} from "assets/css/stylesCss";

// 給湯器全体写真
const ZentaiSmall = require("assets/img/modalImages/modalHowToShootKyutoki/zentai/kyutouki-@1x.png");
const ZentaiMedium = require("assets/img/modalImages/modalHowToShootKyutoki/zentai/kyutouki-@2x.png");
const ZentaiLarge = require("assets/img/modalImages/modalHowToShootKyutoki/zentai/kyutouki-@3x.png");

// 給湯器型番
const KatabanSmall = require("assets/img/modalImages/modalHowToShootKyutoki/kataban/kyutouki_kataban-@1x.png");
const KatabanMedium = require("assets/img/modalImages/modalHowToShootKyutoki/kataban/kyutouki_kataban-@2x.png");
const KatabanLarge = require("assets/img/modalImages/modalHowToShootKyutoki/kataban/kyutouki_kataban-@3x.png");

/**
 * 「給湯器の撮り方」モーダル画面
 */
const ModalHowToShootKyutoki = memo(() => {
  return (
    <>
      <h2>給湯器の撮り方</h2>
      <section css={modalGroup}>
        <p css={mtgBody}>
          代表的な機器の参考写真をご確認ください。ガス機器の型番が判明すると見積もりご依頼後のスムーズな対応が可能です。
        </p>
      </section>
      <section css={modalGroup}>
        <p css={modalLabel}>給湯器全体写真</p>
        <p css={mtgCaption}>
          遠くから機器周辺もわかるように引きの画像を撮影してください。
        </p>
        <img
          css={modalImg}
          src={ZentaiSmall}
          srcSet={`${ZentaiSmall} 1x, ${ZentaiMedium} 2x, ${ZentaiLarge} 3x`}
          alt="給湯器全体写真"
        />
      </section>
      <section css={modalGroup}>
        <p css={modalLabel}>給湯器型番</p>
        <p css={mtgCaption}>
          正面から型番と型式がわかるようにステッカー全体を撮影してください。
        </p>
        <img
          css={modalImg}
          src={KatabanSmall}
          srcSet={`${KatabanSmall} 1x, ${KatabanMedium} 2x, ${KatabanLarge} 3x`}
          alt="給湯器型番"
        />
      </section>
    </>
  );
});

export default ModalHowToShootKyutoki;
